import { jsx } from 'theme-ui';
import styled from '@emotion/styled';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Container } from '../../components/organisms';
import { Flex, Box, Heading} from '@theme-ui/components';
import { StyledDescription } from '.';
import { SearchInputBox } from '../../components/search';

const BannerText = ({ title, subtitle, description, searchURL }) => (
  <Box sx={{ maxWidth: '420px', ml: [0, 0, 4, 5], mt: [0, 0, 5, 5] }}>
    <Heading as='h1' sx={heading}>
      {title} <Box sx={subHeading}>{subtitle}</Box>
    </Heading>
    <StyledDescription dangerouslySetInnerHTML={{ __html: description }} mb={4} />
    <SearchInputBox 
      placeholder= 'Discover More'
      styles={searchStyle}
      searchURL={searchURL}/>
  </Box>
);

const HeroSection = ({ data, bannerImg }) => {
  const searchURL = `/hr-garden/search/?page=1&query=`;
  return (
    <StyledBox>
      <Container>
        <Flex className='garden-banner'
          sx={{
            flexDirection: ['column', 'column', 'column', 'row'],
            justifyContent: ['space-between'],
            alignItems: ['center', 'center', 'flex-start', 'flex-start'],
          }}>
          <BannerText
            title={data.title}
            subtitle={data.subtitle}
            description={data.desc}
            searchURL={searchURL}
          />
          <Box className='banner-img'>
            <GatsbyImage image={getImage(bannerImg)} alt='hr-garden-banner-img' />
          </Box>
        </Flex>
      </Container>
    </StyledBox>
  );
};

const searchStyle = {
  width: ['98%', 406, 406, 406],
  bg: 'white',
  height: 57,
  border: 'none',
  borderRadius: 4,
  button: {
    bg: 'white',
    color: '#ADADAD',
    '&:hover': {
      bg: 'white',
      boxShadow: 'none',
    },
  },
  input: {
    bg: 'white',
    color: '#ADADAD',
    padding: 3,
    height: 57,
    '&:hover': {
      outline: 'none',
      border: 'none',
      boxShadow: 'none',
    },
    '&:focus': {
      outline: 'none',
      border: 'none',
      boxShadow: 'none',
    }
  },
};

const heading = {
  fontSize: [4, '2.625rem'], 
  fontWeight: 400, 
  lineHeight: ['2.25rem','3rem']
}
const subHeading = {
  fontWeight: 600,
  mb: [2, 3],
  color: '#EE7928',
}

const StyledBox = styled(Box)`
    background-color: #F4F2F3;
    @media (min-width: 1024px) {
      padding: 0px;
      .garden-banner {
        height: auto;
        padding: 32px 0px;
      }
    }
    @media (max-width: 1023px) {
      padding: 32px 6px 64px;
      .garden-banner {
        height: 600px;
        padding: 32px 0px;
      }
      .banner-img {
        max-width: 580px;
        position: relative;
        left: 35%;
        bottom: 35%;
      }
    }
    @media (max-width: 900px){
      .garden-banner {
        height: 600px;
      }
      .banner-img {
        max-width: 450px;
        position: relative;
        left: 41%;
        bottom: 27%;
      }
    }
    @media (max-width: 767px) {
      padding: 32px 6px 32px;
      .garden-banner {
        height: auto;
        padding: 32px 0px;
      }
      .banner-img {
        max-width: 420px;
        position: static;
        margin-top: 64px;
      }
    }
    @media (max-width: 639px) {
      padding: 32px 6px 32px;
      .garden-banner {
        padding: 0px;
      }
      .banner-img {
        max-width: 350px;
      }
    }
    @media (max-width: 450px) {
      padding: 32px 6px 32px;
      .garden-banner {
           
      }
      .banner-img {
        max-width: 300px;
      }
    }
    @media (max-width: 400px) {
        padding: 32px 6px 32px;
        .garden-banner {
            
        }
    }
    @media (min-width: 1200px) {
      .banner-img {
        position: relative;
        right: -2%;
      }
    }
    @media (min-width: 1280px) {
      .banner-img {
        position: relative;
        right: -2%;
      }
    }
    @media (min-width: 1400px) {
      .banner-img {
        position: relative;
        right: -10%;
      }
    }
`

export default HeroSection;
